<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title=" Kemasukan Jurnal">
            <w-flex class="mt3">
                <div class="xs4"> 
                    <w-input v-model="cari.tarikh_dari" required label="Tarikh " type="date"  /> 
                </div>
                <div class="xs4"> 
                    <w-input v-model="cari.tarikh_hingga" required label="Tarikh Hingga " type="date"  /> 
                </div>

                <div class="xs4">
                  <w-input label="No. Jurnal" v-model="cari.no_jurnal"> </w-input>
                </div>
                
            </w-flex>
          
            <w-flex class="mt3">
                <div class="xs4">
                  <z-lookup label="Kod Akaun Debit" name="status" :url='service_utiliti+"lookup/akaun_akhir"' :sort="false" :cache="false" v-model="cari.akaun_debit_id" />
                </div>
                &nbsp;&nbsp;
                 <div class="xs4">
                  <z-lookup label="Kod Akaun Kredit" name="status" :url='service_utiliti+"lookup/akaun_akhir"' :sort="false" :cache="false" v-model="cari.akaun_kredit_id" />
                </div>
                &nbsp;&nbsp;
                <div class="xs4">
                  <w-input label="No. Dokumen" v-model="cari.no_dokumen"> </w-input>
                </div>
                
            </w-flex>
            <w-flex class="mt3">
                <div class="xs4">
                  <z-lookup label="Status" name="status" :url='service_utiliti+"lookup/tindakan"' :sort="false" :cache="false" v-model="cari.lkp_tindakan_id" />
                </div>
                <div class="xs4">

                    <!-- <z-lookup :url="service_kutipan +'lookup/jabatan_baharu'" -->
                        <z-lookup :url="service_utiliti +'lookup/jabatan_jurnal'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                            label="jabatan"
                        />
                </div>
            </w-flex>
            
             <div class="mt2 text-right">
                
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                   <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
             </div>

             <div class="mt2 text-right">
                 <w-button bg-color="success" class="mr3" @click="cetakSenarai">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak Senarai
                </w-button>
             </div>
            <br>
            <w-dialog v-model="modal.show" :fullscreen="modal.fullscreen" :width="modal.width" :persistent="modal.persistent" :persistent-no-animation="modal.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                     Paparan Jurnal
                </template>
                <template #default>
                     <w-form ref="form" v-model="modal.valid" @validate="send" @success="success">
                        
                        <w-flex class="mt3">
                          <div class="xs3">
                              <h5 class="fw-semibold m0">
                                  No. Jurnal :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{ form.no_jurnal }} </div>
                          </div>
                          <div class="xs3">
                              <h5 class="fw-semibold m0">
                                  No. Dokumen :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{ form.no_dokumen }} </div>
                          </div>
                          <div class="xs3">
                              <h5 class="fw-semibold m0">
                                  Keterangan :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{ form.keterangan }} </div>
                          </div>
                          <div class="xs3">
                              <h5 class="fw-semibold m0">
                                  Status :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{ form.tindakan_keterangan }} </div>
                          </div>
                        </w-flex>

                        <w-flex class="mt3">
                          <div class="xs4">
                              <!-- <h5 class="fw-semibold m0">
                                  Catatan :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{ form.catatan }} </div> -->
                          </div>
                          
                          <div class="xs4">
                              <h5 class="fw-semibold m0">
                                 
                              </h5>
                              <div class="fw-normal my1 fs-1"> </div>
                          </div>
                          <div class="xs4">
                             
                          </div>
                        </w-flex>
                        <w-tabs :items="tabs" :no-slider="false" active-class="primary">
          
                            <template #item-content.1>
                                <table class="w-table">
                                    <thead>
                                    <tr>
                                        <th class="w-table__header w-table__header--sortable text-left">Kod Akaun</th>
                                        <th class="w-table__header w-table__header--sortable text-left">Amaun Debit (RM)</th>
                                        <th class="w-table__header w-table__header--sortable text-left">Amaun Kredit (RM)</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    
                                        <tr v-for="dt, index in form.jurnal_akaun">
                                            <td class="w-table__cell text-left">
                                                {{dt.akaun_kod}} | {{dt.akaun_keterangan}}
                                            </td>
                                            <td class="w-table__cell text-right">
                                                {{$zutil.currency(dt.amaun_debit)}}
                                            </td>
                                            <td class="w-table__cell text-right">
                                                {{$zutil.currency(dt.amaun_kredit)}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="w-table__cell text-left">Jumlah</th>
                                            <th class="w-table__cell text-right" >{{$zutil.currency(total_debit)}}</th>
                                            <th class="w-table__cell text-right" >{{$zutil.currency(total_kredit)}}</th>
                                        </tr>
                                    </tbody>
                                    
                                </table>
                            </template>
                            <template #item-content.2>
                              <z-jejak-audit :jejak_audit="form.jejak_audit" />
                            </template>
                        </w-tabs>
                        
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="success" class="mr3" @click="cetak(form.id)" v-if="form.lkp_tindakan_id == 4 && $zutil.can('Jurnal Lulus')">
                            <w-icon>fal fa-print</w-icon>
                            &nbsp;Cetak
                    </w-button>
                    <w-button bg-color="grey-light5--bg" @click="modal.show = false">Tutup</w-button>
                    
                        <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === true" @click="$refs.form.validate()" v-if="form.lkp_tindakan_id == 1  && $zutil.can('Jurnal Penyediaan')">
                            Semak
                        </w-button>
                       <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === true" @click="$refs.form.validate()" v-if="form.lkp_tindakan_id == 2 && $zutil.can('Jurnal Lulus')">
                            Lulus
                        </w-button>
                        <!-- <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === true" @click="$refs.form.validate()" v-if="form.lkp_tindakan_id == 2 && $zutil.can('Jurnal Semakan') ">
                            Sah
                        </w-button>
                        <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === true" @click="$refs.form.validate()" v-if="form.lkp_tindakan_id == 3 && $zutil.can('Jurnal Lulus')">
                            Lulus
                        </w-button> -->
                    
                    
                </template>
            </w-dialog>


            <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                  <template v-if="form.id > 0">
                    Kemaskini
                  </template>
                  <template v-else>
                    Tambah
                  </template>
                     Kemasukan Jurnal
                </template>
                <template #default>
                     <w-form ref="form" v-model="dialog.valid" @validate="submit" @success="success">
                        <w-flex justify-space-between class="mb4">
                            <w-select v-model="form.model" :items="models"  label="Sumber *" :validators="[validators.required]" />
                             &nbsp;&nbsp;
                             <template v-if="form.model == 'Lain'">
                            <z-input label="No. Dokumen" v-model="form.no_dokumen" name="no_dokumen"  />
                          </template>
                          <template v-else>
                            <z-input label="No. Dokumen *" v-model="form.no_dokumen" name="no_dokumen" :validators="[validators.required]" />
                          </template>
                            
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                          
                            <z-input label="Perihal Jurnal *" v-model="form.keterangan" name="Keterangan" :validators="[validators.required]" />
                            &nbsp;&nbsp;
                            
                             <w-input   v-model="form.tarikh" name="tarikh" label="Tarikh *" type="date" :validators="[validators.required]"/>
                        </w-flex>
                       <!--  <w-flex justify-space-between class="mb4">
                            <z-input label="Catatan" v-model="form.catatan" name="catatan"  />
                        </w-flex> -->
                        <div class="w-card__content content-hardcode">                
                          <table class="table-dashboard" width="100%">
                           <thead>
                            <tr>
                                <td >Kod Akaun *</td>
                                <td>Vot</td>
                                <td>Amaun Debit (RM)</td>
                                <td>Amaun Kredit (RM)</td>
                                <td><w-icon class="mr1" @click="addItem">fal fa-plus</w-icon></td>
                            </tr>
                             </thead>
                            
                                <tr v-for="dt, index in form.jurnal_akaun">
                                    <td >
                                        <z-lookup name="akaun" :url='service_utiliti+"lookup/akaun_akhir_vot"' :sort="false" :cache="false" v-model="dt.akaun_id" @pilih="Vot_akaun(dt)" :validators="[validators.required]"/>
                                    </td>
                                     <td>
                                       <template v-if="dt.vot_id">
                                            <template v-if="dt.ind_vot_id">
                                               <z-lookup name="vot" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  />
                                           </template>
                                           <template v-else>
                                               <z-lookup name="vot" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  />
                                           </template>
                                       </template>
                                       <template v-else>
                                           <z-lookup name="vot" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="dt.vot_id"  />
                                       </template>
                                        
                                        
                                    </td>
                                    <td>
                                        <z-money v-model:originalValue="dt.amaun_debit" v-on:keyup="cekDebit(dt)" /> 
                                    </td>
                                    <td>
                                         <z-money v-model:originalValue="dt.amaun_kredit" v-on:keyup="cekKredit(dt)" /> 
                                    </td>
                                    <td><w-icon class="mr1" @click="removeItem(index)">fal fa-trash</w-icon></td>
                                </tr>
                                <tr>
                                    <th colspan="2">Jumlah</th>
                                    <td align="right">{{$zutil.currency(total_debit)}}</td>
                                    <td align="right">{{$zutil.currency(total_kredit)}}</td>
                                    <td></td>
                                </tr>
                            
                            
                        </table>
                      </div>
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
                    <template v-if="total_debit == total_kredit">
                        <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">{{form.saveButton}}</w-button>
                    </template>
                    <template v-else>
                        <w-button class="ml1" :loading="dialog.loading" :disabled="true" >{{form.saveButton}}</w-button>
                    </template>
                    
                </template>
            </w-dialog>

            <z-table ref="tbluser" title="Senarai Kemasukan Jurnal" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                <template #button v-if="$zutil.can('Jurnal Penyediaan')">
                    <w-button dark class="indigo-dark2--bg ml1" @click="add()">
                        <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                    </w-button>
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.debit="{ item, label, header, index }">
                    <template v-for="dt, index in item.jurnal_akaun">
                        <template v-if="dt.amaun_debit">
                            <div>{{dt.akaun_kod}} | {{dt.akaun_keterangan}} </div>
                        </template>
                    </template>
                </template>
                <template #item-cell.kredit="{ item, label, header, index }">
                    <template v-for="dt, index in item.jurnal_akaun">
                        <template v-if="dt.amaun_kredit">
                            <div>{{dt.akaun_kod}} | {{dt.akaun_keterangan}} </div>
                        </template>
                    </template>
                </template>
                <template #item-cell.debit_rm="{ item, label, header, index }">
                    <template v-for="dt, index in item.jurnal_akaun">
                        <template v-if="dt.amaun_debit">
                             <div class="text-right">{{$zutil.currency(dt.amaun_debit)}}</div> 
                        </template>
                    </template>
                </template>
                <template #item-cell.kredit_rm="{ item, label, header, index }">
                    <template v-for="dt, index in item.jurnal_akaun">
                        <template v-if="dt.amaun_kredit">
                             <div class="text-right">{{$zutil.currency(dt.amaun_kredit)}}</div> 
                        </template>
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <w-icon tile @click="show(item)">fal fa-eye</w-icon>
                        <template v-if="item.lkp_tindakan_id == 1 && $zutil.can('Jurnal Penyediaan')">
                            &nbsp;&nbsp;
                            <w-icon tile @click="edit(item)">fal fa-pencil</w-icon>
                            &nbsp;&nbsp;
                            <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                        </template>
                        <template v-if="item.lkp_tindakan_id == 2 && $zutil.can('Jurnal Semakan')">
                            &nbsp;&nbsp;
                            <w-icon tile @click="edit(item)">fal fa-pencil</w-icon>
                            &nbsp;&nbsp;
                            <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                        </template>
                        <template v-if="item.lkp_tindakan_id == 3 && $zutil.can('Jurnal Sah')">
                            &nbsp;&nbsp;
                            <w-icon tile @click="edit(item)">fal fa-pencil</w-icon>
                        </template>

                    </w-flex>
                </template>
            </z-table>
           
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_utiliti+'jurnal',
        reload: true,
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Utiliti', route: '/utiliti' },
            { label: 'Jurnal', route: '/utiliti/jurnal' }
          ],
        total_debit : 0,
        total_kredit : 0,
        lookup : 0,
        dt_akaun :{},
        dt_vot :{},
        form :{},
        models : [], 
        vot_ids : [],
        akauns : [],
        tabs: [
            { title: 'Butiran', content: '' },
            { title: 'Jejak Audit', content: '' },
        ],
        cari : {no_jurnal: '', no_dokumen: '', lkp_tindakan_id : '', akaun_debit_id : '', akaun_kredit_id : '', tarikh_dari : '', tarikh_hingga : '', jabatan_id : '' },
       
       
        dialogProfil: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          form: {nama: '', email: ''}
        },
    }
         
  },
  methods: {

    search() {
      var url = window.route('utiliti.jurnal.index')+'?no_jurnal='+this.cari.no_jurnal+'&no_dokumen='+this.cari.no_dokumen+'&lkp_tindakan_id='+this.cari.lkp_tindakan_id+'&akaun_debit_id='+this.cari.akaun_debit_id+'&akaun_kredit_id='+this.cari.akaun_kredit_id+'&tarikh_dari='+this.cari.tarikh_dari+'&tarikh_hingga='+this.cari.tarikh_hingga+'&jabatan_id='+this.cari.jabatan_id;
      this.$inertia.visit(url, { preserveScroll : true})
    },

    reset(){
      this.cari = {no_jurnal: '', no_dokumen: '', lkp_tindakan_id : '', akaun_debit_id : '', akaun_kredit_id : '', tarikh_dari : '', tarikh_hingga : '', jabatan_id : ''}
      this.search()
    },

    cekDebit(dt){
        dt.amaun_kredit = null;
        console.log(dt)
        this.totalDebitKredit();
    },

    cekKredit(dt){
        dt.amaun_debit = null;
        console.log(dt)
        this.totalDebitKredit();
    },

    addItem() {
        this.form.jurnal_akaun.push( {akaun_id : null,vot_id : null, amaun_debit : null, amaun_kredit : null, lama_vot_id : null});
    },

    removeItem(index) {
        this.form.jurnal_akaun.splice(index, 1);
    },

    totalDebitKredit(){
        this.total_kredit = 0;
        this.total_debit = 0;
        for (var i in this.form.jurnal_akaun) {
            if(this.form.jurnal_akaun[i].amaun_debit){
                this.total_debit = this.total_debit + parseFloat(this.form.jurnal_akaun[i].amaun_debit);
            }
            if(this.form.jurnal_akaun[i].amaun_kredit){
                this.total_kredit = this.total_kredit + parseFloat(this.form.jurnal_akaun[i].amaun_kredit);
            }
        }
    },

    add() {
            this.form = {
                id : null,
                lkp_jenis_jurnal_id : 2,
                jabatan_id : null,
                tarikh : null,
                no_dokumen : null,
                keterangan : null,
                catatan : null,
                jurnal_akaun : [
                    {akaun_id : null, amaun_debit : null, amaun_kredit : null},
                    {akaun_id : null, amaun_debit : null, amaun_kredit : null}
                ]
            }
            this.dialog.show = true
            this.form.saveButton = "Simpan"
            this.total_kredit = 0
            this.total_debit = 0
    },

    edit(idx) {
        this.form = idx
        this.form.saveButton = "Kemaskini"
        this.dialog.show = true
        this.totalDebitKredit()
    },

    show(idx) {
        this.form = idx
        this.form.saveButton = "Kemaskini"
        this.modal.show = true
        this.totalDebitKredit()
    },

    getModel() {
           
        this.$zcomm
            .get(
                this.service_utiliti+"lookup/model"
            )
            .then((res) => {
              this.models = res
            })
    },

    send(){
        
        if(this.form.lkp_tindakan_id == 1){
            this.form.lkp_tindakan_id = 2

        // alert(this.form.lkp_tindakan_id);
        }else if(this.form.lkp_tindakan_id == 2){
        //     this.form.lkp_tindakan_id = 3
        // }else if(this.form.lkp_tindakan_id == 3){
            this.form.lkp_tindakan_id = 4
        }
        this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
        .then(res => {
            //update displayed record
            this.mapreturneddata(res)
            this.modal.show = false;

          if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            this.$inertia.visit(this.$page.url)
        })
        .catch(err => {

        })
        .finally(() => {
            this.dialog.loading = false
            // this.dialog.show = false

        });
    },

     getAkauns() {
      
    this.$zcomm.get(this.service_utiliti+'lookup/akaun_akhir_vot').then(res => {
              this.akauns = res;
            });
    },

    getVots(){
       this.$zcomm.get(this.service_utiliti+'lookup/vot').then(res => {
              this.vots = res;
            });
    },
    Vot_akaun(dt){
        
        if(dt.ind_vot_id == 0){
            dt.ind_vot_id = 1
        }else{
            dt.ind_vot_id = 0
        }
        for (var a in this.akauns) {
            if(dt.akaun_id == this.akauns[a].value){
                dt.vot_id = this.akauns[a].vot;
            }
        }
       
    },

    
    cetak(id) {
        // alert (id);
        window.location.href = this.service_utiliti+'jurnal/cetak/'+id,'_blank';
    },

    cetakSenarai() {
         window.open(this.service_utiliti+'jurnal/cetaksenarai/'+'cetak'+'?no_jurnal='+this.cari.no_jurnal+'&no_dokumen='+this.cari.no_dokumen+'&lkp_tindakan_id='+this.cari.lkp_tindakan_id+'&akaun_debit_id='+this.cari.akaun_debit_id+'&akaun_kredit_id='+this.cari.akaun_kredit_id+'&tarikh_dari='+this.cari.tarikh_dari+'&tarikh_hingga='+this.cari.tarikh_hingga+'&jabatan_id='+this.$page.props.auth.user.jabatan_id+'&user_auth='+this.$page.props.auth.user.id,'_blank');
           
    },
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 900
    this.getAkauns();
    this.getVots();
    this.getModel();
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.no_dokumen == 'undefined'){this.cari.no_dokumen = ''}
    if(this.cari.no_jurnal == 'undefined'){this.cari.no_jurnal = ''}
  },
    
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
